import React from 'react';
import { Select, MenuItem, Chip, InputLabel, FormControl, SelectChangeEvent } from '@mui/material';

// Option type for colored select
export interface ColoredOption {
  label: string;
  value: string;
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

/**
 * Props for ColoredSelectField
 * - input, meta: provided by redux-form Field
 * - label: string label for the field
 * - options: array of ColoredOption
 * - disabled: optional boolean
 */
interface ColoredSelectFieldProps {
  input: any;
  meta: any;
  label: string;
  options: ColoredOption[];
  disabled?: boolean;
  translate: (key: string) => string;
}

const ColoredSelectField: React.FC<ColoredSelectFieldProps> = ({
  input,
  label,
  options,
  meta,
  disabled,
  translate
}) => {
  const error = meta.touched && meta.error;
  const labelId = `${input.name}_label`;
  const selectedOption = options.find((opt) => opt.value === input.value);

  return (
    <FormControl fullWidth variant="outlined" margin="dense" error={!!error}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        {...input}
        labelId={labelId}
        id={input.name}
        label={label}
        disabled={disabled}
        onChange={(event: SelectChangeEvent<string>) => input.onChange(event.target.value)}
        renderValue={() => {
          if (!selectedOption) return '';
          return (
            <Chip
              label={translate(selectedOption.label)}
              color={selectedOption.color || 'default'}
              size="small"
              style={{ minWidth: 100 }}
            />
          );
        }}
      >
        {options.map((option) => (
          <MenuItem value={option.value} key={option.value}>
            <Chip
              label={translate(option.label)}
              color={option.color || 'default'}
              size="small"
              style={{ minWidth: 100 }}
            />
          </MenuItem>
        ))}
      </Select>
      {error && (
        <span style={{ color: '#d32f2f', fontSize: 12 }}>{meta.error}</span>
      )}
    </FormControl>
  );
};

export default ColoredSelectField; 